import React from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { useConnect } from '../../../hooks/@lore/query-connect';
import { useUser } from '@lore/auth';

export default function Network(props) {
  const { network } = props;

  const currentUser = useUser();

  const networkSites = useConnect('networkSite.find', {
    where: {
      eager: {
        $where: {
          networkId: network.id
        }
      }
    }
  });

  const userSites = useConnect('networkSite.find', {
    where: {
      eager: {
        $where: {
          networkId: network.id,
          userSites: {
            $where: {
              userId: currentUser.id
            }
          }
        }
      }
    }
  });

  const roleSites = useConnect('networkSite.find', {
    where: {
      eager: {
        $where: {
          networkId: network.id,
          roles: {
            $where: {
              userId: currentUser.id
            }
          },
        }
      }
    }
  });

  if (
    userSites.data.length === 0 &&
    roleSites.data.length === 0
  ) {
    return null;
  }

  return (
    <div className={classNames(
      'flex items-center space-x-3',
      'hover:opacity-60'
    )}>
      <div className={classNames(
        'flex items-center h-14 w-14 overflow-hidden',
        // 'shadow-cs-flat -m-0.5 border-2 rounded-2xl',
        'shadow-cs-flat -m-px border rounded-cs-10',
        'border-cs-gray-200 bg-white'
      )}>
        <img className="h-11 w-11 object-contain m-auto" src={network.data.logo} alt="logo" />
      </div>
      <Link to="/my-network" className={classNames(
        'flex-1'
      )}>
        <div>
          <div className="text-base text-cs-gray-900 font-semibold">
            {network.data.name}
          </div>
          <div className="text-xs text-cs-gray-500">
            P-{userSites.meta?.totalCount} / E-{roleSites.meta?.totalCount} / {networkSites.meta?.totalCount}
          </div>
        </div>
      </Link>
    </div>
  );
};
